// Usporedba teksta bez kvacica.
//
// Zasto: polja za odabir artikla trazila su obicnim podnizom, pa tko upise
// "secer" nije nasao "ŠEĆER". U bazi 42 % naziva artikala ima kvacicu, a kod
// jedne firme 84 % - a na tipkovnici se kvacice redovito preskacu, pa je to
// najcesci razlog da se artikl "ne nade" iako postoji.
//
// Isti postupak vec je koristilo stanje skladista; ovdje je izvucen da ga
// dijele svi ekrani.

/**
 * Mala slova i bez kvacica, za usporedbu.
 * "ŠEĆER" -> "secer", "Džep" -> "dzep"
 */
export const fold = (v) => String(v === null || v === undefined ? '' : v)
  .toLowerCase()
  .replace(/[čć]/g, 'c')
  .replace(/ž/g, 'z')
  .replace(/š/g, 's')
  .replace(/đ/g, 'd')

/**
 * Filtar za v-autocomplete i v-select (Vuetify 2).
 *
 * Potpis je onakav kakav Vuetify salje: (stavka, upit, tekstStavke). Trazi se
 * podniz, isto kao i dosad - jedino se prije usporedbe s obje strane skidaju
 * kvacice, pa "secer" nade "ŠEĆER", a "ŠEĆER" i dalje nade "ŠEĆER".
 */
export const bezKvacica = (stavka, upit, tekstStavke) => {
  const trazim = fold(upit).trim()
  if (!trazim) { return true }
  return fold(tekstStavke).indexOf(trazim) > -1
}

/**
 * Isti filtar, ali trazi SVE upisane rijeci, bilo kojim redom.
 * "kit siliko" nade "KIT SILIKONSKI T IZO 600 ML", a nade ga i "siliko kit".
 */
export const sveRijeci = (stavka, upit, tekstStavke) => {
  const rijeci = fold(upit).split(/\s+/).filter(r => r !== '')
  if (rijeci.length === 0) { return true }
  const tekst = fold(tekstStavke)
  return rijeci.every(r => tekst.indexOf(r) > -1)
}

export default {fold, bezKvacica, sveRijeci}
